(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["hl-back-button"] && !Shopify.designMode) return;
  try {
    class HlBackButton extends HTMLElement {
    connectedCallback() {
      this.referrerCollection = this.findReferrerCollection();

      if (this.referrerCollection) {
        this.syncLink();
        // Variant changes morph the section back to server HTML (which only
        // knows the fallback collection), so re-assert the referrer label.
        this.observer = new MutationObserver(() => this.syncLink());
        this.observer.observe(this, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['href'] });
      }

      this.addEventListener('click', (event) => {
        if (!this.referrerCollection || history.length <= 1) return;
        if (!event.target.closest('a')) return;
        event.preventDefault();
        history.back();
      });
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    syncLink() {
      const link = this.querySelector('a');
      const label = this.querySelector('.hl-back-button__label');
      if (!link || !label) return;
      if (label.textContent !== this.referrerCollection.title) {
        label.textContent = this.referrerCollection.title;
      }
      if (link.getAttribute('href') !== this.referrerCollection.url) {
        link.setAttribute('href', this.referrerCollection.url);
      }
    }

    findReferrerCollection() {
      if (!document.referrer) return null;
      let referrer;
      try {
        referrer = new URL(document.referrer);
      } catch {
        return null;
      }
      if (referrer.origin !== window.location.origin) return null;
      const match = referrer.pathname.match(/\/collections\/([^\/?#]+)/);
      if (!match) return null;
      let collections;
      try {
        collections = JSON.parse(this.dataset.collections || '[]');
      } catch {
        return null;
      }
      return collections.find((c) => c.handle === match[1]) || null;
    }
  }

  if (!customElements.get('hl-back-button')) {
    customElements.define('hl-back-button', HlBackButton);
  }
  } catch(e) { console.error(e); }
})();

})();
